import React from "react";
import { AiFillTags } from "@react-icons/all-files/ai/AiFillTags";

import { Link } from "react-router-dom";

function DarkTags({ tag }) {
  return (
    <div
      title={tag}
      className="Purple-btn-effect relative cursor-pointer w-full 2xl:w-full"
    >
      <Link to={`/browse/?genre=${tag}`}>
        <div className="flex justify-start items-center text-secondary w-full 2xl:w-full  h-[52px] bg-secondary">
          <div className="w-[52px] h-[52px] bg-primary text-tertiary  flex justify-center items-center">
            <AiFillTags className="text-[16px] md:text-[20px]" />
          </div>
          <span className="flex-1 line-clamp-1 px-[30px] text-tertiary capitalize tablet:px-[14px] tablet:text-[14px] font-SoraR">
            {tag}
          </span>
        </div>
      </Link>
    </div>
  );
}

export default DarkTags;
